import { render, staticRenderFns } from "./TrainingDataTable.vue?vue&type=template&id=b5f9643a&scoped=true&"
import script from "./TrainingDataTable.vue?vue&type=script&lang=js&"
export * from "./TrainingDataTable.vue?vue&type=script&lang=js&"
import style0 from "./TrainingDataTable.vue?vue&type=style&index=0&id=b5f9643a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5f9643a",
  null
  
)

export default component.exports